import { render, staticRenderFns } from "./CustomOfficialEvents1.vue?vue&type=template&id=0c7244c0&scoped=true"
import script from "./CustomOfficialEvents1.vue?vue&type=script&lang=js"
export * from "./CustomOfficialEvents1.vue?vue&type=script&lang=js"
import style0 from "./CustomOfficialEvents1.vue?vue&type=style&index=0&id=0c7244c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7244c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7244c0')) {
      api.createRecord('0c7244c0', component.options)
    } else {
      api.reload('0c7244c0', component.options)
    }
    module.hot.accept("./CustomOfficialEvents1.vue?vue&type=template&id=0c7244c0&scoped=true", function () {
      api.rerender('0c7244c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/aggregatePageManagement/components/CustomOfficialEvents1.vue"
export default component.exports